import FilterListingItemContentDefault from './FilterListingItemContentDefault';

export default FilterListingItemContentDefault;
